import type { User_role } from "@prisma/client";
import { useRouter } from "next/router";
import { type ReactNode } from "react";
import { FetchLoader } from "src/component/element/FetchLoader";
import { useGetUserSettingsQuery } from "src/service/UsersApi";

/**
 * rolesNoViewPermissionで受け取った権限は
 * 閲覧できないようにするコンポーネント
 * @example
 *   // roleがSTUDENTのユーザーは閲覧できない
 *    <RoleGuard rolesNoViewPermission={["STUDENT"]}>
 *      <Page />
 *    </RoleGuard>
 *
 */
export const RoleGuard = ({
  rolesNoViewPermission,
  children,
}: {
  children: ReactNode;
  rolesNoViewPermission: User_role[];
}) => {
  const router = useRouter();
  const { data: user, isLoading } = useGetUserSettingsQuery();
  const checkedAuthority = rolesNoViewPermission.filter(
    (role) => role === user?.role,
  );

  if (isLoading) {
    return <FetchLoader />;
  }

  if (
    user?.isUpgradedRole &&
    user.userRoles.some(({ role }) => role === "ADMIN") &&
    !rolesNoViewPermission.includes("ADMIN")
  ) {
    return <>{children}</>;
  }

  if (checkedAuthority.length !== 0) {
    router.push("/mypage");
  } else {
    return <>{children}</>;
  }
  return <></>;
};
